import { Utilities } from '@shared/utilities/utilities.model';
import { DateUtilities } from '@shared/utilities/date-utilities.model';
import { TagItemSettings } from './tag-item.model';

export class UserV3Model {
	static USER_SURVEYOR_NANE: string = 'PERITO';
	static DELIVERY_ITEM_MENU_ID: string = 'DELIVERY_ITEM_MENU_ID';
	static DELIVERY_ASR_ITEM_MENU_ID: string = 'DELIVERY_ASR_ITEM_MENU_ID';
	static PROFILE_ITEM_MENU_ID: string = 'PROFILE_ITEM_MENU_ID';
	static CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID: string = 'CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID';
	static CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID: string = 'CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID';
	static CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID: string = 'CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID';
	static CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID: string = 'CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID';
	static CONTRACT_CLOSING_DK_C_ITEM_MENU_ID: string = 'CONTRACT_CLOSING_DK_C_ITEM_MENU_ID';
	static NOTIFICATION_CENTER_ITEM_MENU_ID: string = 'NOTIFICATION_CENTER_ITEM_MENU_ID';
	static TYRES_ITEM_OPC_MENU_ID: string = 'TYRES_ITEM_OPC_MENU_ID';
	static TYRES_ITEM_OPA_MENU_ID: string = 'TYRES_ITEM_OPA_MENU_ID';
	static TYRES_ITEM_OPF_MENU_ID: string = 'TYRES_ITEM_OPF_MENU_ID';
	static TYRES_ITEM_OPS_MENU_ID: string = 'TYRES_ITEM_OPS_MENU_ID';
	static LOGISTICS_ITEM_OPL_MENU_ID: string = 'LOGISTICS_ITEM_OPL_MENU_ID';
	static LOGISTICS_ITEM_OPC_MENU_ID: string = 'LOGISTICS_ITEM_OPC_MENU_ID';
	static LOGISTICS_ITEM_OPAD_MENU_ID: string = 'LOGISTICS_ITEM_OPAD_MENU_ID';
	static LOGISTICS_ITEM_OPASR_MENU_ID: string = 'LOGISTICS_ITEM_OPASR_MENU_ID';
	static NOT_FOUND_ITEM_MENU_ID: string = 'NOT_FOUND_ITEM_MENU_ID';
	static CLAIMS_ADMIN_ITEM_MENU_ID: string = 'CLAIMS_ADMIN_ITEM_MENU_ID';
	static CLAIMS_CUSTOM_ADMIN_ITEM_MENU_ID: string = 'CLAIMS_CUSTOM_ADMIN_ITEM_MENU_ID';
	static CLAIMS_SUPERVISOR_ITEM_MENU_ID: string = 'CLAIMS_SUPERVISOR_ITEM_MENU_ID';
	static CLAIMS_OLSA_ITEM_MENU_ID: string = 'CLAIMS_OLSA_ITEM_MENU_ID';
	static CLAIMS_REPAIR_ITEM_MENU_ID: string = 'CLAIMS_REPAIR_ITEM_MENU_ID';
	static CLAIMS_APPROPRIATION_ITEM_MENU_ID: string = 'CLAIMS_APPROPRIATION_ITEM_MENU_ID';
	static CLAIMS_PRACTICE_CAR_ITEM_MENU_ID: string = 'CLAIMS_PRACTICE_CAR_ITEM_MENU_ID';
	static CLAIMS_PRACTICES_ITEM_MENU_ID: string = 'CLAIMS_PRACTICES_ITEM_MENU_ID';
	static CLAIMS_COMPLAINT_ITEM_MENU_ID: string = 'CLAIMS_COMPLAINT_ITEM_MENU_ID';
	static CLAIMS_THEFT_ITEM_MENU_ID: string = 'CLAIMS_THEFT_ITEM_MENU_ID';
	static AUTHORITY_ITEM_MENU_ID: string = 'AUTHORITY_ITEM_MENU_ID';
	static INVOICING_ITEM_MENU_ID: string = 'INVOICING_ITEM_MENU_ID';
	static USER_CHANGE_SP_MENU_ID: string = 'USER_CHANGE_SP_MENU_ID';
	static USER_CHANGE_ALD_MENU_ID: string = 'USER_CHANGE_ALD_MENU_ID';
	static MOBILITY_ITEM_MENU_ID: string = 'MOBILITY_ITEM_MENU_ID';


	static ADMINISTRATION_RULES_MENU_ID: string = 'ADMINISTRATION_RULES_MENU_ID';
	static ADMINISTRATION_CHANNELING_MENU_ID: string = 'ADMINISTRATION_CHANNELING_MENU_ID';
	static ADMINISTRATION_USERS_MENU_ID: string = 'ADMINISTRATION_USERS_MENU_ID';
	static ADMINISTRATION_MENU_ID: string = 'ADMINISTRATION_MENU_ID';
	static FLOTTA_POOL_MENU_ID: string = 'FLOTTA_POOL_MENU_ID';
	static BOOKINGS_RELIEF_MENU_ID: string = 'BOOKINGS_RELIEF_MENU_ID';
	static BOOKINGS_PRELEASE_MENU_ID: string = 'BOOKINGS_PRELEASE_MENU_ID';

	static CARGOS_ITEM_MENU_ID: string = 'CARGOS_ITEM_MENU_ID';

	id: string;
	username: string;
	is_active: boolean;
	personal_details: UserV3PersonalDetailsModel;
	custom_data: UserV3CustomDataModel;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.id = model.id;
			this.username = model.username;
			this.is_active = model.is_active;
			this.personal_details = new UserV3PersonalDetailsModel(model.personal_details);
			this.custom_data = new UserV3CustomDataModel();
		}
	}

	setCustomData(model: any): boolean {
		return this.custom_data.setAppSettings(model);
	}

	getAlertsLastAccess(): string {
		if (!Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.alerts_last_access)) {
			return this.custom_data.app_settings.alerts_last_access;
		}
		return DateUtilities.olderDate;
	}

	setAlertsLastAccess(value: string) {
		if (Utilities.isVoid(this.custom_data)) {
			this.custom_data = new UserV3CustomDataModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings)) {
			this.custom_data.app_settings = new UserV3CustomDataAppSettingsModel();
		}
		this.custom_data.app_settings.alerts_last_access = value;
	}

	getAccessedPages(): string[] {
		let res: string[] = [];
		if (!Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.accessed_pages)) {
			res = this.custom_data.app_settings.accessed_pages;
		}
		return res;
	}

	addAccessedPage(page: string) {
		if (Utilities.isVoid(this.custom_data)) {
			this.custom_data = new UserV3CustomDataModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings)) {
			this.custom_data.app_settings = new UserV3CustomDataAppSettingsModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings.accessed_pages)) {
			this.custom_data.app_settings.accessed_pages = [];
		}
		if (!this.custom_data.app_settings.accessed_pages.includes(page)) {
			this.custom_data.app_settings.accessed_pages.push(page);
		}
	}

	getAlertTags(): TagItemSettings[] {
		let res: TagItemSettings[] = [];
		if (!Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.alert_tags)) {
			res = this.custom_data.app_settings.alert_tags;
		}
		return res;
	}

	setAlertTags(tags: TagItemSettings[]) {
		if (Utilities.isVoid(this.custom_data)) {
			this.custom_data = new UserV3CustomDataModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings)) {
			this.custom_data.app_settings = new UserV3CustomDataAppSettingsModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings.alert_tags)) {
			this.custom_data.app_settings.alert_tags = tags; /* TODO: [] */
		}
	}

	isPageAccessed(page: string): boolean {
		return this.getAccessedPages().includes(page);
	}

	getItemsPerPage(): number {
		if (!Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.items_per_page)) {
			const itemsPerPage = this.custom_data.app_settings.items_per_page;
			if (!Utilities.isVoid(itemsPerPage) && !isNaN(itemsPerPage)) {
				return itemsPerPage;
			}
		}
		return 10;
	}

	setItemsPerPage(value) {
		if (Utilities.isVoid(this.custom_data)) {
			this.custom_data = new UserV3CustomDataModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings)) {
			this.custom_data.app_settings = new UserV3CustomDataAppSettingsModel();
		}
		this.custom_data.app_settings.items_per_page = value;
	}

	getNotShowAddToHome() {
		return !Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.not_show_add_to_home)
			&& this.custom_data.app_settings.not_show_add_to_home;
	}

	setNotShowAddToHome(value: boolean) {
		if (Utilities.isVoid(this.custom_data)) {
			this.custom_data = new UserV3CustomDataModel();
		}
		if (Utilities.isVoid(this.custom_data.app_settings)) {
			this.custom_data.app_settings = new UserV3CustomDataAppSettingsModel();
		}
		this.custom_data.app_settings.not_show_add_to_home = value;
	}

	getTemplate(): number {
		if (!Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.template)) {
			return this.custom_data.app_settings.template;
		}
		return 0;
	}

	getFavoritePage(): string {
		if (!Utilities.isVoid(this.custom_data) && !Utilities.isVoid(this.custom_data.app_settings)
			&& !Utilities.isVoid(this.custom_data.app_settings.favorite_page)) {
			return this.custom_data.app_settings.favorite_page;
		}
		return '';
	}
}

export class UserV3PersonalDetailsModel {
	firstname: string;
	lastname: string;

	email: string;
	gender: string;
	office_role: string;
	phone: string;
	birth_date: string;
	birth_place: string;
	birth_province: string;
	birth_country: string;

	tax_code: string;

	constructor(model?: any) {
		this.setProfileData(model);
	}

	setProfileData(model?: any): boolean {
		if (!Utilities.isVoid(model)) {
			this.firstname = Utilities.isVoid(model.firstname) ? '' : model.firstname;
			this.lastname = Utilities.isVoid(model.lastname) ? '' : model.lastname;
			this.gender = Utilities.isVoid(model.gender) ? '' : model.gender;
			this.email = Utilities.isVoid(model.email) ? '' : model.email;
			this.office_role = Utilities.isVoid(model.office_role) ? '' : model.office_role;
			this.phone = Utilities.isVoid(model.phone) ? '' : model.phone;
			this.birth_date = Utilities.isVoid(model.birth_date) ? '' : model.birth_date;
			this.birth_place = Utilities.isVoid(model.birth_place) ? '' : model.birth_place;
			this.birth_province = Utilities.isVoid(model.birth_province) ? '' : model.birth_province;
			this.birth_country = Utilities.isVoid(model.birth_country) ? '' : model.birth_country;
			this.tax_code = Utilities.isVoid(model.tax_code) ? '' : model.tax_code;
			return true;
		}
		return false;
	}
}

export class UserV3CustomDataModel {
	static LEVEL_APP_SETTINGS: string = 'app_settings';
	static LEVEL_TEMPLATE: string = 'template';
	static LEVEL_ACCESSED_PAGES: string = 'accessed_pages';
	static LEVEL_ITEMS_PER_PAGE: string = 'items_per_page';
	static LEVEL_ALERT_LAST_ACCESS: string = 'alerts_last_access';
	static LEVEL_NOT_SHOW_ADD_TO_HOME: string = 'not_show_add_to_home';
	static LEVEL_ALERT_TAGS: string = 'alert_tags';
	static LEVEL_FAVORITE_PAGE: string = 'favorite_page';

	app_settings: UserV3CustomDataAppSettingsModel;

	constructor() {
		this.app_settings = new UserV3CustomDataAppSettingsModel();
	}

	setAppSettings(model?: any): boolean {
		if (!Utilities.isVoid(model)) {
			this.app_settings = new UserV3CustomDataAppSettingsModel(model.app_settings);
			return true;
		}
		return false;
	}
}

export class UserV3CustomDataAppSettingsModel {
	static ORDERS_PER_PAGE: string = 'orders';
	static ALERTS_PER_PAGE: string = 'alerts';
	static DEADLINES_PER_PAGE: string = 'deadlines';
	static APPOINTMENTS_PER_PAGE: string = 'appointments';
	static CONTRACTS_PER_PAGE: string = 'contracts';
	static PLANNING_CENTER_PER_PAGE: string = 'planning_center';
	static PLANNING_LIST_PER_PAGE: string = 'planning_list';
	static REPORTS_PER_PAGE: string = 'reports';
	static SURVEYORS_PER_PAGE: string = 'surveyors';
	static THREADS_PER_PAGE: string = 'threads';
	static PLANNING_USERS_PER_PAGE: string = 'planning_users';
	static APPROPRIATIONS_PER_PAGE: string = 'appropriations';
	static PRACTICE_CAR_PER_PAGE: string = 'practice_car';
	static CUSTOM_ITEM_PER_PAGE: string = 'custom_item';
	static USERS_PER_PAGE: string = 'users';

	template: number;
	accessed_pages: string[];
	items_per_page: number;
	alerts_last_access: string;
	favorite_page: string;
	not_show_add_to_home: boolean;
	alert_tags: TagItemSettings[];

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.template = !Utilities.isVoid(model.template) ? model.template : 0;
			this.accessed_pages = [];
			if (!Utilities.isVoid(model.accessed_pages)) {
				for (const page of model.accessed_pages) {
					this.accessed_pages.push(page);
				}
			}
			this.alert_tags = [];
			if (!Utilities.isVoid(model.alert_tags)) {
				for (const page of model.alert_tags) {
					this.alert_tags.push(page);
				}
			}
			this.items_per_page = model.items_per_page;
			//TODO custom items per page!

			// this.items_per_page = new Map<string, number>();
			// if (!Utilities.isVoid(model.items_per_page)) {
			// 	const keys = Object.keys(model.items_per_page);
			// 	for (const key of keys) {
			// 		this.items_per_page.set(key, Object[key]);
			// 	}
			// }
			this.favorite_page = model.favorite_page;
			this.alerts_last_access = model.alerts_last_access;
			this.not_show_add_to_home = !Utilities.isVoid(model.not_show_add_to_home) ? model.not_show_add_to_home : false;
		}
	}
}
